import React, {useMemo} from 'react';
import {RocketLaunchIcon} from '@heroicons/react/24/outline';
import {useEditor} from '@craftjs/core';
import {useEditorDevice} from 'hooks';

import EditorToolbox from '../../toolboxes/Editor.Toolbox';
import EditorContentLauncher from './Editor.Content.Launcher';

interface IEditorToolboxLauncherProps {}

const EditorToolboxLauncher = ({}: IEditorToolboxLauncherProps) => {
  const device = useEditorDevice();
  const {nodes, query} = useEditor(state => ({
    nodes: state.nodes,
  }));

  const hasNode = useMemo(() => {
    return query.serialize().includes('EditorContentLauncher');
  }, [nodes, query]);

  const disabled = device === 'desktop' || hasNode;

  return (
    <EditorToolbox
      key={`${disabled}`}
      icon={<RocketLaunchIcon />}
      text="Launcher"
      info="This component is mobile only"
      disabled={disabled}
      showExclamation={!hasNode}>
      <EditorContentLauncher />
    </EditorToolbox>
  );
};

export default React.memo(EditorToolboxLauncher);
